import React from 'react'
import Navbar from './Navbar'

export default function About() {
    return (
        <>
            <Navbar />
            comming soon.....
        </>
    )
}
